import {Input, Component, OnInit, Output, EventEmitter, SimpleChange} from '@angular/core';


@Component({
    selector: 'app-search-box',
    templateUrl: './search-box.component.html',
    styleUrls: ['./search-box.component.scss']
})
export class SearchBoxComponent implements OnInit
{
    @Input()  public value: string;
    @Output() public valueChange = new EventEmitter<string>();

    constructor() { }

    ngOnInit(): void
    {
    }

    public onChanges(newValue: string): void
    {
        this.value = newValue;
        this.valueChange.emit(newValue);
    }
}
